import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
// Replaced import from package temporarily until the package got fixed
// import * as lightbox from '@elements/lightbox';
import * as lightbox from './libs/@elements/lightbox/dist';
lightbox.init({
        plugins: ['zoom', 'video'],
        zoom: true,
        video: true
    }
);


import * as formValidation from './libs/@elements/form-validation';
formValidation.init({
    trigger: {event: 'false'}
});

import * as switchButton from './scripts/switch-button';
switchButton.init();

import * as anchorNav from './scripts/anchor-nav';

import * as affix from "./libs/@elements/affix";
affix.init({
        offset: 80,
        breakpoints: {
            768: {
                offset: 116
            },
            1200: {
                offset: 170
            }
        }
    }
);


import * as ajaxForm from './libs/@elements/ajax-form';
ajaxForm.init();

import * as scrollSlider from './scripts/scroll-slider';
scrollSlider.init();

import * as sharing from './scripts/sharing';
sharing.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();